<footer>

  <div class="container-fluid bg-dark bg-opacity-75 pt-2">

    <div class="container">

      <!-- Desktop -->
      <div class="row pb-4 d-none d-md-flex">
        <div class="col-auto">

          <mat-list>
            <div class="heading" mat-subheader>Company</div>
            <mat-list-item role="listitem" style="height:auto;"><span class="item">Lakeshore Landing Inc.</span></mat-list-item>
            <mat-list-item role="listitem" style="height:auto;"><span class="item">1072 Lakeshore Drive</span></mat-list-item>
            <mat-list-item role="listitem" style="height:auto;"><span class="item">Gravenhurst, Ontario</span></mat-list-item>
            <mat-list-item role="listitem" style="height:auto;"><a class="item" [routerLink]="['/contact']">705-955-2330 - Steve</a></mat-list-item>
            <mat-list-item role="listitem" style="height:auto;"><a class="item" [routerLink]="['/contact']">289-440-2200 - Ed</a></mat-list-item>
            <mat-list-item role="listitem" style="height:auto;"><a class="item" [routerLink]="['/contact']">admin@lakeshorelanding.ca</a></mat-list-item>
          </mat-list>

        </div>
      </div>

      <!-- Mobile -->
      <div class="d-md-none pb-4">
        <div class="accordion" id="footerAccordion">

          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingSite">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSite">
                Site
              </button>
            </h2>
            <div id="collapseSite" class="accordion-collapse collapse" data-bs-parent="#footerAccordion">
              <div class="accordion-body bg-dark p-2">
                <ul class="list-unstyled mb-0">
                  <li><a class="item" routerLink="/home">Home</a></li>
                  <li><a class="item" routerLink="/contact">Contact Us</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingCompany">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCompany">
                Company
              </button>
            </h2>
            <div id="collapseCompany" class="accordion-collapse collapse show" data-bs-parent="#footerAccordion">
              <div class="accordion-body bg-dark p-2">
                <ul class="list-unstyled mb-0">
                  <li>Lakeshore Landing Inc.</li>
                  <li>1072 Lakeshore Drive</li>
                  <li>Gravenhurst, Ontario</li>
                  <li><a class="item" routerLink="/contact">705-955-2330 - Steve</a></li>
                  <li><a class="item" routerLink="/contact">289-440-2200 - Ed</a></li>
                  <li><a class="item" routerLink="/contact">admin@lakeshorelanding.ca</a></li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Bottom -->
      <div class="row justify-content-center pb-4">
        <div class="col-auto">

            <a href="https://northportage.ca" class="item footer-bottom-link" target="_blank" rel="noopener">
              &copy; {{year}} Lakeshore Landing 
            </a>

        </div>
      </div>
    </div>

  </div>

</footer>